import React from 'react'

const IconThumbsDownButton = ({ isClicked = false, fill = '#fff' }) => {
  return (
    <>
      {isClicked ? (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' fill='#EE2534' />
          <mask
            id='mask0_18101_3573'
            style={{
              maskType: 'alpha',
            }}
            maskUnits='userSpaceOnUse'
            x='6'
            y='6'
            width='20'
            height='20'
          >
            <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_18101_3573)'>
            <path
              d='M7.83203 18.1663V16.2128L10.5435 9.83301H20.1462V18.1663L14.7552 23.4932L14.0933 23.2897L14.9283 18.1663H7.83203ZM19.4795 10.4997H10.9827L8.4987 16.3282V17.4997H15.6718L14.8112 22.5301L19.4795 17.8938V10.4997ZM20.1462 18.1663V17.4997H23.4987V10.4997H20.1462V9.83301H24.1654V18.1663H20.1462Z'
              fill='#fff'
            />
          </g>
        </svg>
      ) : (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' stroke='#EE2534' fill={fill} />
          <mask
            id='mask0_18101_3573'
            style={{
              maskType: 'alpha',
            }}
            maskUnits='userSpaceOnUse'
            x='6'
            y='6'
            width='20'
            height='20'
          >
            <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_18101_3573)'>
            <path
              d='M7.83203 18.1663V16.2128L10.5435 9.83301H20.1462V18.1663L14.7552 23.4932L14.0933 23.2897L14.9283 18.1663H7.83203ZM19.4795 10.4997H10.9827L8.4987 16.3282V17.4997H15.6718L14.8112 22.5301L19.4795 17.8938V10.4997ZM20.1462 18.1663V17.4997H23.4987V10.4997H20.1462V9.83301H24.1654V18.1663H20.1462Z'
              fill='#EE2534'
            />
          </g>
        </svg>
      )}
    </>
  )
}

export default IconThumbsDownButton
